import assetPath from '/app/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/sarah-baudzus.256x256.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')